import * as React from 'react';
import styles from './index.less';
import { FI18n } from '@freelog/tools-lib';

interface ResourceLabelsCardProps {
  labels: string[];

  style?: React.CSSProperties;

  onClick?(): void;

  /** 为 true 时不展示可点击 hover（仅展示） */
  readOnly?: boolean;
}

function FResourceLabelsCard({
  labels,
  style = {},
  onClick,
  readOnly = false,
}: ResourceLabelsCardProps) {
  if (labels.length > 0) {
    return (
      <div
        className={`${styles.ResourceLabelsCard_hasData}${
          readOnly ? ` ${styles.readOnly}` : ''
        }`}
        onClick={readOnly ? undefined : onClick}
        style={style}
      >
        {labels.map((l, li) => {
          return <label key={li}>{l}</label>;
        })}
      </div>
    );
  }

  return (
    <div
      className={`${styles.ResourceLabelsCard}${readOnly ? ` ${styles.readOnly}` : ''}`}
      onClick={readOnly ? undefined : onClick}
      style={style}
    >
      <span>{FI18n.i18nNext.tAuto('brr_resourcelisting_item_btn_addtags')}</span>
    </div>
  );
}

export default FResourceLabelsCard;
